<div class="g_title mt-3 text-center" (click)="debug($event)">Liste des programmes</div>

<div class="font-italic text-center mb-2" [class]="{ 'text-green-500': programOnAir }">
  <span class="underline">Programme en cours:</span> {{ currentProgramInfoTxt }}
  <div>
    <span class="underline">Plage horaire:</span> {{ currentProgramTimeTxt }}
    @if(programOnAir) {
    <span class="ml-3 text-red font-bold">!!PROGRAMME ACTIF!!</span>
    }
  </div>
</div>

<div class="mt-1 text-center text-sm small-btn">
  <p-button label="Modifier le programme en cours" (click)="showPopupCurrentProgram()"></p-button>
</div>

<p-dialog
  [(visible)]="popupCurrentProgram"
  [modal]="true"
  class="popupMessage"
  [header]="'Modification du programme en cours'"
>
  <div class="content m-auto">
    <div class="font-italic mb-2">
      <div>Programme en cours:</div>
      <p-dropdown
        [(ngModel)]="popupProgramId"
        (ngModelChange)="onCurrentProgramChange()"
        [options]="programsOptions"
        placeholder="Selectionner un programme"
        optionValue="id"
        optionLabel="label"
        appendTo="body"
        [showClear]="true"
      >
      </p-dropdown>
    </div>
    <div class="font-italic mb-2">
      <div>Plage horaire:</div>
      <p-calendar
        appendTo="body"
        [(ngModel)]="popupTimeStart"
        [showTime]="true"
        hourFormat="24"
        dateFormat="dd/mm/yy"
      />
      <p-calendar appendTo="body" [(ngModel)]="popupTimeEnd" [showTime]="true" hourFormat="24" dateFormat="dd/mm/yy" />
    </div>
  </div>

  <div class="ui-dialog-footer text-center mt-4 flex justify-content-around">
    <p-button (click)="saveCurrentProgram()">Enregistrer</p-button>
    <p-button (click)="popupCurrentProgram = false">Annuler</p-button>
  </div>
</p-dialog>

<div class="mt-6 text-center scroller">
  @for (program of programs; track program.id) {
  <div
    class="flex align-items-center justify-content-center"
    [class]="{ 'text-green-500': currentProgramInfo?.id === program.id }"
  >
    <a target="_blank" [href]="'/program/' + program.id" title="Voir le programme">
      <i class="pi pi-eye ml-3 mr-3 cursor-pointer"></i>
    </a>
    <a [href]="'/admin/program/logs/' + program.id" title="Voir les logs">
      <i class="pi pi-chart-line mr-3 cursor-pointer"></i>
    </a>
    <div [routerLink]="'/admin/program/' + program.id" class="cursor-pointer" title="Modifier le programme">
      <i class="pi pi-pencil mr-3"></i>
      {{ program.name }} ~ {{ program.date }} ~ {{ program.town }}
    </div>
    <i
      title="Dupliquer le programme"
      class="pi pi-clone ml-3 opacity-40 cursor-pointer"
      (click)="duplicate(program)"
    ></i>
  </div>
  <div class="mt-3 mb-4 separator_prog">
    <div class="line"></div>
  </div>
  }
</div>

@if (showCreate) {
<div class="mt-6 text-center">
  <p-button label="Créer un programme" [routerLink]="'/admin/program'"></p-button>
</div>
}
